<template lang="pug">
  div
    v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .content-layout(v-else)
      v-card(outlined flat)
        v-simple-table.mytable(fixed-header)
          template(v-slot:default)
            thead(style="height: 57px")
              tr
                th.text-left.s2.primary400--text.pl-3.pr-0(style="background-color: #f7f7f7") {{ $t('gateway') }}
                th.text-left.s2.primary400--text.px-0.mx-0.text-center(style="background-color: #f7f7f7") {{ $t('activate') }}
                th.text-left.s2.primary400--text.px-0.mx-0(style="background-color: #f7f7f7")
            tbody
              tr(v-if="gateways[0].allowed && yezzapay")
                td.py-3.pl-3.pr-0
                  div.s2.default--text Stripe
                  div.f2.basic600--text(v-html="$t('stripe_text')")
                td.py-3.px-0.mx-0
                  div.d-flex.align-center.justify-center
                    div
                      y-switch.mb-n3(:color="$vuetify.theme.themes[$theme].success400" :disabled="!isAvailable(gateways[0].id)" v-model="gateways[0].default" @change="updateDefault(gateways[0].id)")
                td.pa-3(align="center")
                  v-btn.button-AA-tiny.primary500--text(outlined color='primary' small @click.stop="openYezzaPay()" height="22px" width="68px" :disabled="isFetchingStatus")
                    div(v-if="!isAvailable(gateways[0].id)") {{ $t('activate') }}
                    div(v-else) {{ $t('manage') }}
              tr(v-if="gateways[0].allowed && yezzapay")
                td.py-3
                  div.s2.default--text SecurePay
                  div.f2.basic600--text {{ $t('secure_pay_text') }}
                td.py-3.px-0.mx-0
                  div.d-flex.align-center.justify-center
                    div
                      y-switch.mb-n3(:color="$vuetify.theme.themes[$theme].success400" :disabled="!isAvailable(gateways[4].id)" v-model="gateways[4].default" @change="updateDefault(gateways[4].id)")
                td.pa-3(align="center")
                  v-btn.button-AA-tiny.primary500--text(outlined color='primary' small @click.stop="updatePaymentGateway(gateways[4].id)" height="22px" width="68px" :disabled="isFetchingStatus")
                    div(v-if="!isAvailable(gateways[4].id)") {{ $t('activate') }}
                    div(v-else) {{ $t('manage') }}
              tr(v-if=" index != 0 && index != 4 && gateway.allowed && showAllPaymentOptions" v-for="(gateway, index) in gateways" :key="gateway.name")
                td.py-3
                  div.s2.default--text {{ gateway.name }}
                td.py-3.px-0.mx-0
                  div.d-flex.align-center.justify-center
                    div
                      y-switch.mb-n3(:color="$vuetify.theme.themes[$theme].success400" :disabled="!isAvailable(gateway.id)" v-model="gateway.default" @change="updateDefault(gateway.id)")
                td.pa-3(align="center")
                  v-btn.button-AA-tiny.primary500--text(outlined color='primary' small @click.stop="updatePaymentGateway(gateway.id)" height="22px" width="68px" :disabled="isFetchingStatus")
                    div(v-if="isAvailable(gateway.id)") {{ $t('manage') }}
                    div(v-else) {{ $t('activate') }}

      .guide.ma-2.c1.basic600--text.d-flex
        eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
        div.c1.basic600--text(v-html="$t('payment_gateway_footnote')")

    .modals
      update-yezza-pay(v-if="showActivateYZpayDialog" :open.sync="showActivateYZpayDialog" :company="company" @activated="handleActivateGateway")
      update-bill-plz(v-if="showUpdateBillPlzDialog" :open.sync="showUpdateBillPlzDialog" :company="company" @activated="handleActivateGateway")
      update-molpay(v-if="showUpdateMolPayDialog" :open.sync="showUpdateMolPayDialog" :company="company" @activated="handleActivateGateway")
      update-2c2p(v-if="showUpdate2c2pDialog" :open.sync="showUpdate2c2pDialog" :company="company" @activated="handleActivateGateway")
      update-securepay(v-if="showUpdateSecurepayDialog" :open.sync="showUpdateSecurepayDialog" :company="company" @activated="handleActivateGateway")
      update-stripe(v-if="showUpdateStripeDialog" :open.sync="showUpdateStripeDialog" :company="company" @activated="handleActivateGateway")
      update-xendit(v-if="showUpdateXenditDialog" :open.sync="showUpdateXenditDialog" :company="company" @activated="handleActivateGateway")


</template>

<script>
import { mapActions, mapState } from 'vuex'
import UpdateYezzaPay from '@/components/dialogs/settings/UpdateYezzaPay.vue'
import UpdateBillPlz from '@/components/dialogs/settings/UpdateBillPlz.vue'
import UpdateMolpay from '@/components/dialogs/settings/UpdateMolpay.vue'
import Update2c2p from '@/components/dialogs/settings/Update2c2p.vue'
import UpdateSecurepay from '@/components/dialogs/settings/UpdateSecurepay.vue'
import UpdateStripe from '@/components/dialogs/settings/UpdateStripe.vue'
import UpdateXendit from '@/components/dialogs/settings/UpdateXendit.vue'

export default {
  name: 'OnlinePaymentList',
  components: { UpdateYezzaPay, UpdateBillPlz, UpdateMolpay, Update2c2p, UpdateSecurepay, UpdateStripe, UpdateXendit },
  props: ['company', 'yezzapay'],
  data: () => ({
    isFetching: true,
    gatewayStatus: null,
    isFetchingStatus: true,
    showActivateYZpayDialog: false,
    showUpdateBillPlzDialog: false,
    showUpdate2c2pDialog: false,
    showUpdateSecurepayDialog: false,
    showUpdateMolPayDialog: false,
    showUpdateStripeDialog: false,
    showUpdateXenditDialog: false,
    gateways: [
      {
        name: 'Yezzapay',  // 0
        id: 'yezzapay',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: 'Billplz',  // 1
        id: 'billplz',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: 'MOLPay',  // 2
        id: 'molpay',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: '2c2p',  // 3
        id: 'twoctwop',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: 'SecurePay',  // 4
        id: 'securepay',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: 'Stripe',  // 5
        id: 'stripe',
        default: false,
        enabled: true,
        allowed: true
      },
      {
        name: 'Xendit',  // 6
        id: 'xendit',
        default: false,
        enabled: false,
        allowed: false
      },
    ]
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaTrial', 'yezzaSubscription']),
    showAllPaymentOptions () {
      if (this.yezzapay) {
        if (this.yezzaSubscription.value || this.yezzaTrial.value) {
          return false
        }
        return true
      }
      return true
    }
  },
  mounted () {
    this.fetchAllowedPaymentGateways()
    this.fetchGatewayStatus()
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    fetchSettings() {
      this.isFetching = true
      this.$axios.get(`/companies/${this.company.id}/`).
        then((response) => {
          if (response.data.default_payment_gateway) {
            this.gateways.forEach((item, i) => {
              if (item.id == response.data.default_payment_gateway) {
                this.gateways[i].default = true
              } else {
                this.gateways[i].default = false
              }
            })
          }
          this.isFetching = false
          this.handleClickFromYezzaPayNoticeBanner()
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchAllowedPaymentGateways() {
      this.$axios.get(`/companies/${this.company.id}/allowed_payment_gateways/`)
        .then(resp => {
          this.gateways[0].allowed = resp.data.yezzapay
          this.gateways[1].allowed = resp.data.billplz
          this.gateways[2].allowed = resp.data.molpay
          this.gateways[3].allowed = resp.data.twoctwop
          this.gateways[4].allowed = resp.data.securepay
          this.gateways[5].allowed = resp.data.stripe
          this.gateways[6].allowed = resp.data.xendit
        })
        .catch(() => {})
    },
    fetchGatewayStatus() {
      this.$axios.get(`/companies/${this.company.id}/payment_gateway_status/`)
        .then((response) => {
          this.isFetchingStatus = false
          this.gatewayStatus = response.data
        })
        .catch(() => {})
    },
    updateDefault(id) {

      let defaultId = null
      let changeIndex = null
      this.gateways.forEach((item, i) => {
        if (item.id == id && this.gateways[i].default) {
          defaultId = id
          changeIndex = i
        } else {
          this.gateways[i].default = false
        }
      })
      const params = {
        default_payment_gateway: defaultId
      }
      this.axios.patch(`/companies/${this.company.id}/`, params)
        .then(() => {
          this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
        })
        .catch(() => {
          if (changeIndex != null) {
            this.gateways[changeIndex].default = false
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
    },
    isAvailable(id) {
      if (!this.gatewayStatus) return false
      if (id === 'yezzapay') {
        return this.gatewayStatus.yezzapay
      } else if (id === 'billplz') {
        return this.gatewayStatus.billplz
      } else if (id === 'molpay') {
        return this.gatewayStatus.molpay
      } else if (id === 'twoctwop') {
        return this.gatewayStatus.twoctwop
      } else if (id === 'securepay') {
        return this.gatewayStatus.securepay
      } else if (id === 'stripe') {
        return this.gatewayStatus.stripe
      } else if (id === 'xendit') {
        return this.gatewayStatus.xendit
      }
    },
    updatePaymentGateway(id) {
      if (id === 'billplz') {
        this.showUpdateBillPlzDialog = true
      } else if (id === 'molpay') {
        this.showUpdateMolPayDialog = true
      } else if (id === 'twoctwop') {
        this.showUpdate2c2pDialog = true
      } else if (id === 'securepay') {
        this.showUpdateSecurepayDialog = true
      } else if (id === 'stripe') {
        this.showUpdateStripeDialog = true
      }else if (id === 'xendit') {
        this.showUpdateXenditDialog = true
      }
    },
    openYezzaPay () {
      this.showActivateYZpayDialog = true
    },
    handleActivateGateway (val) {
      if (val === 'yezzapay') {
        this.gateways[0].default = true
        this.updateDefault(val)
      }
      this.fetchGatewayStatus()
    },
    handleClickFromYezzaPayNoticeBanner () {
      if (this.$store.state.ui.yezzapayMigrateModal) {
        this.openYezzaPay()
        this.$store.commit('ui/setYezzapayMigrateModal', false)
      }
      this.$watch('$store.state.ui.yezzapayMigrateModal', (val) => {
        if (val) {
          this.openYezzaPay()
          this.$store.commit('ui/setYezzapayMigrateModal', false)
        }
      })

      if (this.$store.state.ui.securepayMigrateModal) {
        this.showUpdateSecurepayDialog = true
        this.$store.commit('ui/setSecurepayMigrateModal', false)
      }
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.showUpdateSecurepayDialog = true
          this.$store.commit('ui/setSecurepayMigrateModal', false)
        }
      })
    }
  }
}
</script>

<style scoped>
.mytable table th {
    background-color: #F7F7F7;
    border-bottom: none;
}
</style>

<i18n>
{
  "en": {
    "gateway": "Gateway",
    "stripe_text": "Individual Sellers or<br>SSM Registered Business",
    "stripe_text_2": "SSM Registered Business",
    "secure_pay_text": "SSM Registered Business",
    "payment_gateway_footnote": "Please ensure activated payment gateway is <b>working properly.</b>"
  },
  "id": {
    "gateway": "Portal/Metode",
    "stripe_text": "Penjual Perorangan atau<br></br>Bisnis Terdaftar SSM",
    "stripe_text_2": "Bisnis terdaftar SSM",
    "secure_pay_text": "Bisnis terdaftar SSM",
    "payment_gateway_footnote": "Pastikan kanal pembayaran yang diaktifkan <b>berfungsi dengan baik.</b>"
  }
}
</i18n>
